import { render, staticRenderFns } from "./roleItem.vue?vue&type=template&id=10a270ee&scoped=true"
import script from "./roleItem.vue?vue&type=script&lang=js"
export * from "./roleItem.vue?vue&type=script&lang=js"
import style0 from "./roleItem.vue?vue&type=style&index=0&id=10a270ee&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10a270ee",
  null
  
)

export default component.exports